import { render, staticRenderFns } from "./AlertConfirmModalsIcon.vue?vue&type=template&id=61f5ae99"
import script from "./AlertConfirmModalsIcon.vue?vue&type=script&lang=js"
export * from "./AlertConfirmModalsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports